import { render, staticRenderFns } from "./bannersList.vue?vue&type=template&id=75526cc1&"
import script from "./bannersList.vue?vue&type=script&lang=js&"
export * from "./bannersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports